import React from 'react';

const AdmissionProcess = () => {
  return (
    <div className="bg-white py-10 px-4 md:px-10">
      <div className="mx-auto text-center">
        <h1 className="mb-4">Admission Process</h1>
        <p className="mb-8">
          Watch the video below to understand the step-by-step admission process at Khwaja Yunus Ali University.
        </p>

        <div className="aspect-w-16 aspect-h-9 w-full rounded-2xl overflow-hidden shadow-lg">
          <iframe
            width="560" height="315"
            src=""
            title="Admission Process - KYAU"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>

        <div className="mt-10 text-sm text-gray-400">
          &copy; {new Date().getFullYear()} Khwaja Yunus Ali University — Online Admission System
        </div>
      </div>
    </div>
  );
};

export default AdmissionProcess;
